import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Wordmark, LINKS, scrollToHash } from "../components/Nav";

export default function Footer() {
  const [contact, setContact] = useState(null);

  useEffect(() => {
    api
      .get("/site/contact")
      .then((r) => setContact(r.data.contact_email))
      .catch(() => {});
  }, []);

  return (
    <footer data-testid="site-footer" className="grain relative bg-navy-abyss py-16 text-cream">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col justify-between gap-10 md:flex-row md:items-start">
          <div>
            <Wordmark tone="dark" />
            <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.3em] text-gold-light/80">
              Rest. Renew. Write. Connect.
            </p>
            <p className="mt-6 max-w-sm text-xs leading-relaxed text-cream/50">
              Our inaugural retreat is in development. No payments or reservations are accepted at
              this time.
            </p>
          </div>
          <nav aria-label="Footer" className="flex flex-col gap-3">
            {LINKS.map((l) => (
              <a
                key={l.hash}
                href={l.hash}
                data-testid={"footer-link-" + l.label.toLowerCase().replace(/[^a-z]+/g, "-")}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToHash(l.hash);
                }}
                className="w-max font-mono text-[11px] uppercase tracking-[0.18em] text-cream/60 transition-colors hover:text-gold-light"
              >
                {l.label}
              </a>
            ))}
          </nav>
          <div className="max-w-sm">
            <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-gold-light/80">Privacy notice</p>
            <p className="mt-4 text-xs leading-relaxed text-cream/50" data-testid="footer-privacy">
              When you submit an interest form, we store the information you provide in a private
              database used only by Chaplain at Sea to plan retreats and respond to interest. We do
              not sell your information. Information submitted through the CCCHAPS opportunities
              form is shared with California Corporate Chaplains only with your consent. You may
              ask us to delete your information at any time
              {contact ? (
                <>
                  {" "}— write to us at <a href={"mailto:" + contact} className="text-gold-light underline" data-testid="footer-contact-email">{contact}</a>
                </>
              ) : (
                "; a contact address will be published here when available"
              )}
              .
            </p>
            <a href="/admin" data-testid="footer-admin-link" className="mt-6 inline-block font-mono text-[10px] uppercase tracking-[0.24em] text-cream/35 transition-colors hover:text-gold-light/70">
              Admin
            </a>
          </div>
        </div>
        <div className="mt-14 border-t border-cream/10 pt-6">
          <p className="text-[11px] text-cream/35">© {new Date().getFullYear()} Chaplain at Sea. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
